import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class WaitingListService {

  constructor (
    private db: AngularFirestore,
  ) { }

  loadWaitingList (product_id: any) {

    return this.db.collection<any>('sbccv_waiting_list', ref => ref
      .where('product.id', '==', product_id)
      .where('waiting', '==', true)
      .orderBy('createdAt', 'desc')).snapshotChanges()

  }

  updateWaiting (id: string, waiting: boolean, allowed: boolean) {
    return this.db.collection('sbccv_waiting_list').doc(id).set({
      'waiting': waiting,
      'allowed': allowed,
    }, {'merge': true});
  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }


}
